const scrollToTop = {
  init() {
    const btnTargetTop = document.querySelector('.btn-to-top');

    if (btnTargetTop) {
      window.onscroll = function() {
        getScrollPage();
      };
      btnTargetTop.addEventListener('click', setTopScroll);
    }

    function getScrollPage() {
      if (document.body.scrollTop > 900 || document.documentElement.scrollTop > 900) {
        btnTargetTop.style.display = 'flex';
      } else {
        btnTargetTop.style.display = 'none';
      }
    }

    function setTopScroll() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  },
};

export default scrollToTop;
